/*
 * Fade-in for Text Area blocks.
 *
 * Opt-in per Text Area via the "Fade in text" setting. Matches the look of the
 * testimonials carousel fade (opacity 0 -> 1, 0.3s ease-in-out) but triggered
 * when the text scrolls into view rather than on slide change.
 *
 * The element starts at opacity 0 (CSS, scoped to .js so no-JS users still see
 * it); this observer adds .is-visible when it enters the viewport, and the CSS
 * transition does the rest. Reduced-motion users get full opacity immediately
 * (handled in CSS), so nothing here needs to run for them.
 */
(function () {
  if (window.__cuyTextFade) return;
  window.__cuyTextFade = true;

  var SELECTOR = '[data-cuy-fade]';
  var BOUND_ATTR = 'data-cuy-fade-bound';

  function reveal(el) {
    el.classList.add('is-visible');
  }

  var supportsObserver = 'IntersectionObserver' in window;
  var observer = null;

  if (supportsObserver) {
    observer = new IntersectionObserver(function (entries) {
      for (var i = 0; i < entries.length; i++) {
        if (entries[i].isIntersecting) {
          reveal(entries[i].target);
          observer.unobserve(entries[i].target);
        }
      }
    }, {
      // Start the fade a little before the block is fully on screen.
      rootMargin: '0px 0px -10% 0px',
      threshold: 0.15
    });
  }

  function scan() {
    var els = document.querySelectorAll(SELECTOR + ':not([' + BOUND_ATTR + '])');
    for (var i = 0; i < els.length; i++) {
      var el = els[i];
      el.setAttribute(BOUND_ATTR, 'true');
      if (supportsObserver) {
        observer.observe(el);
      } else {
        reveal(el); // no observer support: just show it
      }
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scan);
  } else {
    scan();
  }

  // Theme editor: re-scan when a section/block is re-rendered.
  document.addEventListener('shopify:section:load', scan);
  document.addEventListener('shopify:block:select', scan);
})();
